import { Component, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DrawerComponent, DrawerItemExpandedFn, DrawerMode, DrawerSelectEvent } from '@progress/kendo-angular-layout';
import { User } from 'src/app/global-functions';
import { CustomMessagesService } from '../../services/custom-messages.service';
import { Profiles } from 'src/app/utils/profiles';
import { Solutions } from 'src/app/utils/solutions';

@Component({
    selector: 'maters-root',
    templateUrl: './master.component.html'
})
export class MasterComponent implements OnDestroy {
    public selected = 'Team';
    public items: Array<any> = [];
    public customMsgService: CustomMessagesService;
    public mode: DrawerMode = 'push';
    public mini = true;
    public expanded = true;

    constructor(private router: Router, public msgService: MessageService) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.draw();
    }

    draw() {
        this.router.events.subscribe((route: any) => {
            if (route instanceof NavigationStart) {
                this.items = this.drawerItems().map((item) => {
                    if (item.path && item.path === route.url) {
                        item.selected = true;
                        return item;
                    } else {
                        item.selected = false;
                        return item;
                    }
                });
            }
        });
        this.setDrawerConfig();
        this.customMsgService.localeChange.subscribe(() => {
            this.items = this.drawerItems();
        });
        window.addEventListener('resize', () => {
            this.setDrawerConfig();
        });
    }

    ngOnDestroy() {
        window.removeEventListener('resize', () => { });
    }

    public setDrawerConfig() {
        const pageWidth = window.innerWidth;
        if (pageWidth <= 770) {
            this.mode = 'overlay';
            this.mini = false;
        } else {
            this.mode = 'push';
            this.mini = true;
        }
    }

    public drawerItems() {
        var user = User.userInSession();
        var idFuncao = user.IDFuncao;
        var idSolucao = user.IDSolucaoEntidade;

        //Alterar cor principal
        var corPrincipal = user.CorPrincipalEntidade;
        document.documentElement.style.setProperty('--theme-color-principal', corPrincipal);

        //Alterar cor secundaria
        var carSecundaria = user.CorSecundariaEntidade;
        document.documentElement.style.setProperty('--theme-color-secondary', carSecundaria);

        //Dashboard Luggage
        var accessDashboardLuggageProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Dashboard Office
        var accessDashboardOfficeProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            //Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Locais
        var accessLocaisProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Armarios
        var accessArmariosProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Teams
        var accessTeamsProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            //Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Users
        var accessUsersProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            //Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Reservas
        var accessReservasProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            //Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Movimentos
        var accessMovimentosProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            //Profiles.Manutencao,
            //Profiles.Limpeza,
        ];

        //Alterar Password
        var accessAlterarPasswordProfiles = [
            Profiles.Administrador,
            Profiles.Supervisor,
            Profiles.Manutencao,
            Profiles.Limpeza,
        ];

        //* Solucões

        //dashboard Luggage
        var accessDashboardLuggageSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.Luggage,
            //Solutions.Office
        ];

        //dashboard Office
        var accessDashboardOfficeSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            //Solutions.Luggage,
            Solutions.Office
        ];

        //Locais
        var accessLocaisSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Armarios
        var accessArmariosSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Teams
        var accessTeamsSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Users
        var accessUsersSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Reservas
        var accessReservasSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.Luggage,
            //Solutions.Office
        ];

        //Movimentos Luggage
        var accessMovimentosSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            Solutions.Luggage,
            //Solutions.Office
        ];

        //Movimentos Office
        var accessMovimentosOfficeSolutions = [
            //Solutions.IndustrialVending,
            //Solutions.ToolManegament,
            //Solutions.Luggage,
            Solutions.Office
        ];

        //Alterar Password
        var accessAlterarPasswordSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Parametros
        var accessParametrosSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        //Entidades
        var accessEntidadesSolutions = [
            Solutions.IndustrialVending,
            Solutions.ToolManegament,
            Solutions.Luggage,
            Solutions.Office
        ];

        var menus = new Array<any>();

        //Dashboard
        if (idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('luggage'), icon: 'k-i-chart-line-markers', path: '/dashboardlug', selected: true });
            menus.push({ text: this.customMsgService.translate('office'), icon: 'k-i-chart-line-markers', path: '/dashboardoffice', selected: true });
        }
        else {
            if (accessDashboardLuggageProfiles.indexOf(idFuncao) >= 0 && accessDashboardLuggageSolutions.indexOf(idSolucao) >= 0) {
                menus.push({ text: this.customMsgService.translate('dashboard'), icon: 'k-i-chart-line-markers', path: '/dashboardlug', selected: true });
            }
            if (accessDashboardOfficeProfiles.indexOf(idFuncao) >= 0 && accessDashboardOfficeSolutions.indexOf(idSolucao) >= 0) {
                menus.push({ text: this.customMsgService.translate('dashboard'), icon: 'k-i-chart-line-markers', path: '/dashboardoffice', selected: true });
            }
        }

        //Gestão de armários
        if (accessArmariosProfiles.indexOf(idFuncao) >= 0 || accessLocaisProfiles.indexOf(idFuncao) >= 0 && accessArmariosSolutions.indexOf(idSolucao) >= 0 || accessLocaisSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ separator: true });
            menus.push({ text: this.customMsgService.translate('gestaoArmarios'), selected: false, disabled: true });
        }
        if (accessLocaisProfiles.indexOf(idFuncao) >= 0 && accessLocaisSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('locais'), icon: 'k-i-marker-pin', path: '/sites', selected: false });
        }
        if (accessArmariosProfiles.indexOf(idFuncao) >= 0 && accessArmariosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('armarios'), icon: 'k-i-set-column-position', path: '/lockers', selected: false });
        }

        //Gestão de utilizadores
        if (accessTeamsProfiles.indexOf(idFuncao) >= 0 && accessTeamsSolutions.indexOf(idSolucao) >= 0 || accessUsersProfiles.indexOf(idFuncao) >= 0 && accessUsersSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ separator: true });
            menus.push({ text: this.customMsgService.translate('gestaoUtilizadores'), selected: false, disabled: true });
        }
        if (accessTeamsProfiles.indexOf(idFuncao) >= 0 && accessTeamsSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('teams'), icon: 'k-i-myspace', path: '/teams', selected: false });
        }
        if (accessUsersProfiles.indexOf(idFuncao) >= 0 && accessUsersSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('users'), icon: 'k-i-user', path: '/users', selected: false });
        }

        //gestao de reservas
        if (accessReservasProfiles.indexOf(idFuncao) >= 0 && accessReservasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ separator: true });
            menus.push({ text: this.customMsgService.translate('gestaoReservas'), selected: false, disabled: true });
        }
        //Reservas
        if (accessReservasProfiles.indexOf(idFuncao) >= 0 && accessReservasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('reservas'), icon: 'k-i-clock', path: '/reservations', selected: false });
        }
        //pagamentos
        if (accessReservasProfiles.indexOf(idFuncao) >= 0 && accessReservasSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('pagamentos'), icon: 'k-i-dollar', path: '/payments', selected: false });
        }

        //Eventos
        if (accessMovimentosProfiles.indexOf(idFuncao) >= 0 && accessMovimentosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ separator: true });
            menus.push({ text: this.customMsgService.translate('eventos'), selected: false, disabled: true });
        }
        if (accessMovimentosProfiles.indexOf(idFuncao) >= 0 && accessMovimentosSolutions.indexOf(idSolucao) >= 0 || idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('movimentos'), icon: 'k-i-rotate', path: '/movements', selected: false });
        }

        //Configurações
        if (idFuncao == Profiles.AdministradorGeral) {
            menus.push({ separator: true });
            menus.push({ text: this.customMsgService.translate('configuracoes'), selected: false, disabled: true });
        }
        if (idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('entidades'), icon: 'k-i-list-unordered-outline', path: '/entities', selected: false });
        }
        if (idFuncao == Profiles.AdministradorGeral) {
            menus.push({ text: this.customMsgService.translate('parametros'), icon: 'k-i-cog', path: '/parameters', selected: false });
        }
        
        return menus;
    }

    public toggleDrawer(drawer: DrawerComponent): void {
        drawer.toggle();
    }

    public isItemExpanded: DrawerItemExpandedFn = (item): boolean => {
        return true;
    };

    public onSelect(ev: DrawerSelectEvent, drawer: DrawerComponent): void {
        drawer.autoCollapse = false;
        this.router.navigate([ev.item.path]);
        this.selected = ev.item.text;
        this.expanded = true;
    }
}
